


















































import { computed, defineComponent, PropType, ref, watch } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import { TagInfo } from "@scrile/api-provider/dist/api/TagsProvider";
import { isMobile } from "@/lib/browserUtils";
import BaseButton from "@/components/BaseButton";
import BaseInput from "@/components/BaseInput";
import BasePage from "@/components/BasePage";
import BaseSpinner from "@/components/BaseSpinner";
import CustomScroll from "@/components/CustomScroll";
import TagItem from "@/components/TagItem";

export default defineComponent({
  name: "SelectTagsView",
  components: { TagItem, BasePage, BaseButton, BaseSpinner, CustomScroll, BaseInput },
  props: {
    selectedTagIds: { type: Array as PropType<string[]>, default: () => [] },
    tags: { type: Array as PropType<TagInfo[]>, required: true },
    showSaveButton: { type: Boolean, default: false },
    saveButtonText: { type: String as PropType<TranslateResult | string>, required: true },
    minSelectedTags: { type: Number, required: true },
    maxSelectedTags: { type: Number, required: true },
  },
  setup(props, { emit }) {
    const saving = ref(false);
    const showAllTags = ref(true);
    const searchTagValue = ref("");

    const selectedTags = ref<TagInfo[]>(props.tags.filter(tag => props.selectedTagIds.includes(tag.id)));
    const unhiddenTagsCount = computed(() => (isMobile() ? 10 : 20));
    const saveButtonDisabled = computed(() => selectedTags.value.length < props.minSelectedTags);
    const tagsToRender = computed<TagInfo[]>(() => {
      return props.tags
        .sort((a, b) => {
          const normalizeA = a.title.toLowerCase();
          const normalizeB = b.title.toLowerCase();
          return normalizeA > normalizeB ? 1 : normalizeA < normalizeB ? -1 : 0;
        })
        .filter(tag => tag.title.toLowerCase().includes(searchTagValue.value.toLowerCase()));
    });

    const selectTag = (tag: TagInfo, value: boolean) => {
      if (selectedTags.value.length >= props.maxSelectedTags && value) return;
      if (value) {
        selectedTags.value.push(tag);
      } else {
        selectedTags.value = selectedTags.value.filter(t => t.id !== tag.id);
      }
      emit("input", selectedTags.value);
    };

    const isTagSelected = (tag: TagInfo) => !!selectedTags.value.find(t => t.id === tag.id);

    const save = () => {
      saving.value = true;
      emit("save", selectedTags.value, () => (saving.value = false));
    };

    const clearTags = () => (selectedTags.value = []);

    watch(
      tagsToRender,
      () => {
        showAllTags.value = tagsToRender.value.length <= unhiddenTagsCount.value;
      },
      { immediate: true }
    );

    emit("clear", clearTags);

    return {
      saving,
      showAllTags,
      searchTagValue,
      unhiddenTagsCount,
      selectedTags,
      tagsToRender,
      saveButtonDisabled,
      isTagSelected,
      selectTag,
      save,
    };
  },
});
